import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=545fb6a9&scoped=true&"
import script from "./Roles.vue?vue&type=script&lang=js&"
export * from "./Roles.vue?vue&type=script&lang=js&"
import style0 from "./Roles.vue?vue&type=style&index=0&id=545fb6a9&scoped=true&lang=css&"
import style1 from "./Roles.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545fb6a9",
  null
  
)

export default component.exports